import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyAWS3SJdLcQpIHlFCfiaCAd7F-8DvapqHE",
  authDomain: "miyazaki-quiz-industry.firebaseapp.com",
  projectId: "miyazaki-quiz-industry",
  storageBucket: "miyazaki-quiz-industry.firebasestorage.app",
  messagingSenderId: "1071826650489",
  appId: "1:1071826650489:web:9c6579e8ee0b60fa4e1ba8"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
